import dayjs from "dayjs"
import React, { FunctionComponent } from "react"
import { FormControl, OverlayTrigger, Table, Tooltip } from "react-bootstrap"
import RoleTypes from "src/pages/hr/Types/RoleTypes"
import roleAssignmentHelper from "../../Utils/RoleAssignmentHelper"
import RoleAssignmentPermissionControls from "../RoleAssignmentPermissionControls/RoleAssignmentPermissionControls"
import "./RoleAssignmentAllRoles.css"

interface Props {
    manageParentState: Function
    roles: RoleTypes[]
    allChecked: boolean
    readonly: boolean
}

const RoleAssignmentAllRoles: FunctionComponent<Props> = (props) => {

    const { manageParentState, roles, allChecked, readonly } = props
    const { timeZoneOffset, timeFormat, roleTableItems, lookupHashTableItem, addOrDropRole, checkOrUncheckAll } = roleAssignmentHelper
    const debug = true

    const allRolesTooltip = (text: string) => {
        return (
            <Tooltip id="role-assignment-all-roles-tooltip" style={{ margin: 0 }}>
                {text}
            </Tooltip>
        )
    }

    // console.log("RoleAssignmentAllRoles props", props)
    // console.log("RoleAssignmentAllRoles getStorage()", getStorage())

    return (
        <div className="RoleAssignmentAllRoles">
            <Table id="role-assignment-all-roles-table">
                <thead>
                    <tr id="role-assignment-all-roles-table-header">
                        {roleTableItems.map((thItem, i) =>
                            <th
                                id={`role-assignment-all-roles-table-header-th-${thItem.key.toLowerCase()}`}
                                style={{ width: thItem.width ? thItem.width : "unset" }}
                                key={i}>
                                <div className="RoleAssignmentAllRolesTHWrapper">
                                    {i < 1 && <div className="RoleAssignmentAllRolesTableCheckbox">
                                        <FormControl
                                            onChange={() => {
                                                checkOrUncheckAll(roles, !allChecked)
                                                manageParentState([{ key: "allChecked" }])
                                            }}
                                            checked={allChecked}
                                            disabled={readonly}
                                            type="checkbox"
                                        />
                                    </div>}
                                    <p>{thItem.title}</p>
                                </div>
                            </th>)}
                        <th id="role-assignment-all-roles-table-header-th-permisions">
                            <div className="RoleAssignmentAllRolesTHWrapper">
                                Permissions
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {roles.map((role, i) => {
                        const bucketItem = lookupHashTableItem(role.PortalRoleId)
                        return (
                            <tr className={`RoleAssignmentAllRolesTRWrapper${bucketItem[1].dropRole ? "Red" : bucketItem[1].addRole ? "Green" : "White"}`} key={i}>
                                {roleTableItems.map((tdItem, j) =>
                                    <td
                                        id={`role-assignment-all-roles-list-table-td-${tdItem.key.toLowerCase()}`}
                                        style={{ width: tdItem.width ? tdItem.width : "unset" }}
                                        key={j}
                                        onClick={() => {
                                            if (!readonly) {
                                                addOrDropRole(bucketItem)
                                                //just to trigger a rerender after the hash table is updated
                                                manageParentState(() => [{ key: "busy", value: false }])
                                            }
                                        }}
                                    >
                                        <div className="RoleAssignmentAllRolesTDWrapper">
                                            {j < 1 &&
                                                <div className="RoleAssignmentAllRolesTableCheckbox">
                                                    <FormControl
                                                        onChange={() => null}
                                                        checked={(bucketItem[1].hasRole && !bucketItem[1].dropRole) || bucketItem[1].addRole}
                                                        disabled={readonly}
                                                        type="checkbox"
                                                    />
                                                </div>}
                                            {(j === 0 && debug) && <p className="RoleAssignmentAllRolesTDWrapperDebug">{role.PortalRoleId}</p>}
                                            <div className="RoleAssignmentAllRolesTableContent">
                                                {tdItem.popover && <div className={`RoleAssignmentAllRolesTableContentHelp ${(bucketItem[1].dropRole || bucketItem[1].addRole) ? "RoleAssignmentAllRolesTableContentHelpWhite" : "RoleAssignmentAllRolesTableContentHelpGrey"}`}>
                                                    {/*@ts-ignore*/}
                                                    <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={allRolesTooltip(role[tdItem.key])}>
                                                        <span className="material-icons">description</span>
                                                    </OverlayTrigger>
                                                </div>}
                                                {!tdItem.isCheckBox && <p>
                                                    {/*@ts-ignore*/
                                                        !(tdItem.isDate && !tdItem.marquee) ? role[tdItem.key]
                                                            /*@ts-ignore*/
                                                            : dayjs.utc(role[tdItem.key]).utcOffset(timeZoneOffset).format(timeFormat)}
                                                </p>}
                                                {/*@ts-ignore*/}
                                                {tdItem.isCheckBox && <div className={`f7d0c564b742b1b08d7cf22ea65b02 ${role[tdItem.key] ? "f7d0c564b742b1b08d7cf22ea65b02Yes" : "f7d0c564b742b1b08d7cf22ea65b02No"}`}>
                                                    {/*@ts-ignore*/}
                                                    <span className="material-icons">{`${role[tdItem.key] ? "done" : "close"}`}</span>
                                                </div>}
                                            </div>
                                        </div>
                                    </td>
                                )}
                                <td id="role-assignment-all-roles-table-header-td-permisions">
                                    <div className="RoleAssignmentAllRolesTDWrapper">
                                        <RoleAssignmentPermissionControls
                                            manageParentState={manageParentState}
                                            bucketItem={bucketItem}
                                            readonly={readonly}
                                        />
                                    </div>
                                </td>
                            </tr>
                        )
                    }
                    )}
                </tbody>
            </Table>
        </div>
    )
}

export default RoleAssignmentAllRoles